import {course_getCourseSubjects_Api} from 'apis'
import {getId} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import React from 'react'
import ContainerPicker from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import useTranslate from "../../../../modules/local/useTranslate";

export const SubjectSelector = ({
                                    name,
                                    value,
                                    course_id,
                                    customConfigs = {},
                                    onChange = NullAsDefault,
                                    ...props
                                }) => {
    const t = useTranslate();
    const defaultValue = getId(value) ?? value
    return (
        <ContainerPicker
            name={name}
            allowClear={true}
            defaultValue={defaultValue}
            type={AppEntities.UNDEFINED}
            placeholder="click to select"
            renderInnerWrapper={InnerWrapper}
            getOption={(option) => {
                return {
                    ...option?.subject,
                    number_of_sessions: option.number_of_sessions,
                    passed_attendance_percentage: option.passed_attendance_percentage,
                    passed_score: option.passed_score
                }
            }}
            renderOption={renderBaseOption(defaultValue, (option) => ({
                title: (
                    <div className="font-bold text-sm text-color-000">
                        {option?.title}
                    </div>
                ),
                description: <span className="text-color-500">{`${option?.number_of_sessions} ${t('sessions')}`}</span>,
            }))}
            onOptionChange={(option) => {
                onChange(createValue(name, option ?? null))
            }}
            customConfigs={{
                apiInfo: course_getCourseSubjects_Api,
                query: bindQueryParam({id: course_id}),
                ...customConfigs
            }}
            {...props}
        />
    )
}
